import { render, staticRenderFns } from "./listaVideoTutoriales.vue?vue&type=template&id=6f8420d2"
import script from "./listaVideoTutoriales.vue?vue&type=script&lang=js"
export * from "./listaVideoTutoriales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports